import StageCard from './stage-card'

export default StageCard
